import { Component, OnInit, inject } from '@angular/core';
import moment from 'moment';
import { BsModalRef } from 'ngx-bootstrap/modal';

import { HomeService } from '@pages/home/services/home.service';
import { SmService } from '@pages/sm/services/sm.service';
import { ClockInOutService } from '@core/services/clock-in-out.service';
import { LineType } from '@shared/model/line-type.model';
import { MechanicFormData } from '@shared/model/mechanic-type-data.model';
import { JobFormData } from '@shared/model/job-type-data.model';

@Component({
    selector: 'app-clockin-job-modal',
    templateUrl: './clockin-job-modal.component.html',
    styleUrls: ['./clockin-job-modal.component.css'],
    standalone: false
})
export class ClockinJobModalComponent implements OnInit {
  private readonly homeService = inject(HomeService);
  private readonly bsModalRef = inject(BsModalRef);
  private readonly smService = inject(SmService);
  private readonly clockinService = inject(ClockInOutService);

  portalSettings: any;
  employeeInfo: any;
  formData: { [key: string]: any } = {};
  userAction: string;
  lineTypes: LineType[] = [];
  scopeList: any[] = [];
  payTypeList: any[] = [];
  workOrderList: any[] = [];
  lastClockinType: any;

  ngOnInit(): void {
    this.formData.lineType = null;
    this.formData.workOrder = null;
    this.formData.scope = null;
    this.formData.payType = null;
    this.clockinService.resetMechanicFormData(this.formData);
    this.resetJobTypeFormData();
    this.formData.lineType =
      this.lineTypes.length == 1 || !this.lineTypes.some(lineType => lineType.Value == this.lastClockinType)
        ? this.lineTypes[0].Value
        : this.lastClockinType;

    if (this.formData.lineType === 'S') {
      this.getWorkOrder();
    }
  }

  clockInClicked(): void {
    this.userAction = 'Clock In';
    this.bsModalRef.hide();
  }

  cancelClicked(): void {
    this.userAction = 'cancel';
    this.bsModalRef.hide();
  }

  onJobDropdownChange(data: JobFormData): void {
    this.clockinService.updateJobFormData(this.formData, data);
  }

  async getWorkOrder(): Promise<void> {
    this.workOrderList = [];
    const response = await this.smService.getWorkOrderTripsByEmployee(this.employeeInfo.Employee, this.employeeInfo.PRCo);
    if (response != null && Array.isArray(response)) {
      this.workOrderList = response.map(val => ({
        ...val,
        ScheduledDateDisplay: val.ScheduledDate != null ? moment(val.ScheduledDate).utc().format('DD/MMM') : '',
        Display: `${val.ScheduledDate != null ? moment(val.ScheduledDate).utc().format('DD/MMM') + ' - ' : ''}WO #${val.WorkOrder} ${val.TripDescription}`,
      }));
    }
  }

  async getScope(): Promise<void> {
    this.scopeList = [];
    const response = await this.smService.getWorkOrderScopes('?sMWorkOrderID=' + this.formData.workOrder.SMWorkOrderID);
    if (response != null && Array.isArray(response)) {
      this.scopeList = response;
      this.scopeList = response.map(val => ({
        ...val,
        Display: val.Scope + ' - ' + val.ScopeDetails,
      }));
    }
  }

  async getPayType(): Promise<void> {
    this.payTypeList = [];
    if (this.formData.workOrder.SMCo != null) {
      const response = await this.smService.getSMPayTypes(this.formData.workOrder.SMCo);
      if (response != null && Array.isArray(response)) {
        this.payTypeList = response.map(val => ({
          ...val,
          Display: val.DatabaseValue + ' - ' + val.DisplayValue,
        }));
      }
    }
  }

  workOrderChanged(): void {
    this.formData.scope = null;
    this.formData.payType = null;
    if (this.formData.workOrder != null) {
      this.getScope();
      this.getPayType();
    } else {
      this.scopeList = [];
      this.payTypeList = [];
    }
  }

  typeChanged(): void {
    if (this.formData.lineType == 'J') {
      this.resetJobTypeFormData();
    } else if (this.formData.lineType == 'S') {
      this.resetSMTypeFormData();
      this.getWorkOrder();
    } else if (this.formData.lineType == 'M') {
      this.clockinService.resetMechanicFormData(this.formData);
    }
  }

  disableClockInButton(): boolean {
    return (
      (this.formData.lineType == 'J' && !this.formData.isJobFormValid) ||
      (this.formData.lineType == 'S' &&
        (this.formData.workOrder == null || this.formData.scope == null || this.formData.payType == null)) ||
      (this.formData.lineType == 'M' && !this.formData.isMechanicformValid)
    );
  }

  onMechanicDropdownChange(data: MechanicFormData): void {
    this.clockinService.updateMechanicFormData(this.formData, data);
  }

  resetJobTypeFormData(): void {
    this.clockinService.resetJobFormData(this.formData);
  }

  resetSMTypeFormData(): void {
    this.formData.workOrder = null;
    this.formData.scope = null;
    this.formData.payType = null;
    this.workOrderList = [];
    this.scopeList = [];
    this.payTypeList = [];
  }
}
